import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { useTranslate } from 'hooks/use-translation';

interface Props {
  closeModal: () => void;
  isVisible: boolean;
  toggleAutoCompression: () => void;
  isAutoCompressTurnedOn: boolean;
}

export const AutoCompressModal: FC<Props> = ({
  closeModal,
  isVisible,
  toggleAutoCompression,
  isAutoCompressTurnedOn,
}) => {
  const translate = useTranslate();
  const enableTitle = translate(
    'templates.dynamic_conditions.compress_timeline_modal_heading',
    {
      action: isAutoCompressTurnedOn ? 'off' : 'on',
    },
  );
  const yesButtonText = translate(
    'templates.dynamic_conditions.compress_timeline_modal_confirmation.cta_submit',
    {
      action: isAutoCompressTurnedOn ? 'off' : 'on',
    },
  );
  const noButtonText = translate('no');

  return (
    <Modal
      visible={isVisible}
      title={enableTitle}
      okText={yesButtonText}
      okButtonProps={{ type: 'primary', danger: false }}
      cancelText={noButtonText}
      onCancel={closeModal}
      onOk={toggleAutoCompression}
    >
      <FormattedMessage
        id="templates.dynamic_conditions.compress_timeline_modal_description"
        values={{ br: () => <br /> }}
      />
    </Modal>
  );
};
